import(/* webpackMode: "eager" */ "/var/www/appagent/src/app/(landing)/pricing/page.tsx");
